import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardIos';
import TypographyWithTooltip from 'components/shared/TypographyWithTooltip';
import Zoom from '@material-ui/core/Zoom';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Container from 'components/Container';
import Page from 'layout/Page';
import useApi, { GET_AVAILABLE_DASHBOARDS_SHARED_WITH_ME } from 'hooks/useApi';

const useStyles = makeStyles(theme => ({
  container: {
    position: 'relative',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      borderBottom: `1px solid ${theme.palette.white}`,
      color: theme.palette.white,
      '& $description': {
        color: theme.palette.white
      },
      '& $buttonIcon': {
        backgroundColor: theme.palette.white
      },
      '& $link': {
        color: theme.palette.white
      },
      '& $arrowIcon': {
        color: theme.palette.primary.main
      }
    },
    '@media (max-width: 330px)': {
      width: '250px'
    }
  },
  title: {
    fontSize: '16px',
    textTransform: 'uppercase',
    fontWeight: '600'
  },
  description: {
    fontSize: '12px',
    color: theme.palette.grey.dark
  },
  link: {
    color: theme.palette.accent.main,
    textDecoration: 'none',
    fontWeight: '600',
    position: 'absolute',
    top: '67%',
    width: '50%',
    '@media (min-width:115px)': {
      width: '124px'
    }
  },
  buttonIcon: {
    backgroundColor: `${theme.palette.lightBlue.main}33`,
    marginRight: '10px',
    padding: '7px'
  },
  arrowIcon: {
    color: theme.palette.accent.main,
    fontSize: '20px'
  }
}));

const DashboardsSharedWithMe = () => {
  const [state, makeRequest] = useApi();
  const { data } = state;

  const classes = useStyles();

  useEffect(() => {
    makeRequest(GET_AVAILABLE_DASHBOARDS_SHARED_WITH_ME());
  }, []); // eslint-disable-line

  return (
    <Page title="Dashboards shared with me">
      <Container center maxWidth="xl">
        <Grid container direction="row" justify="flex-start" alignItems="stretch">
          {data &&
            data.map(sharedDashboard => (
              <Grid item xs={12} md={3} key={sharedDashboard.id}>
                <Box
                  width="100%"
                  p={2}
                  boxShadow={2}
                  borderTop={3}
                  borderColor="#346C9F"
                  height="150px"
                  className={classes.container}
                >
                  <TypographyWithTooltip
                    tooltipProps={{ placement: 'top', TransitionComponent: Zoom, arrow: true }}
                    variant="h5"
                    gutterBottom
                    className={classes.title}
                  >
                    {sharedDashboard.name}
                  </TypographyWithTooltip>

                  <Link to={`/dashboard/${sharedDashboard.id}`} className={classes.link}>
                    <IconButton size="small" className={classes.buttonIcon}>
                      <ArrowForwardIcon size="small" className={classes.arrowIcon} />
                    </IconButton>
                    View more
                  </Link>
                </Box>
              </Grid>
            ))}
        </Grid>
      </Container>
    </Page>
  );
};

export default DashboardsSharedWithMe;
